<app-jackpot-skins-row [skins]="jackpot.allSkins()" />
<div class="jp--main">
  <div class="jp--left">
    <app-jackpot-wheel></app-jackpot-wheel>
    <app-jackpot-stats></app-jackpot-stats>
  </div>
  <div class="jp--right">
    <app-jackpot-info-bar></app-jackpot-info-bar>
    <app-jackpot-bets [round]="jackpot.jackpot()!"></app-jackpot-bets>
    <div class="jp--history">
      @for (jp of jackpot.history(); track $index) {
      <app-jackpot-bets [round]="jp"></app-jackpot-bets>
      }
    </div>
  </div>
</div>
